import type { StaffAnalyticsAccess } from "@lafayette/schemas";

import { Icon } from "../../ui/icon";
import { dateText } from "../format";

// The privacy line under the header (Paper: "Analytics consent given · Staff only · Kept 13 months"): the consent state in words, who may see it,
// and how long app data is kept. It states what the page really does, so each part is a fact of the answer, never a promise of the page.

function consentWords(access: Pick<StaffAnalyticsAccess, "consent">): string {
  return access.consent.optedOut
    ? "Analytics consent: not given. Only records are shown."
    : "Analytics consent: given.";
}

export function PrivacyLine({ access }: Readonly<{ access: StaffAnalyticsAccess }>) {
  return (
    <p className="m-0 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-hairline bg-card px-3.5 py-2.5 text-[13px] leading-[18px] text-muted-foreground">
      <Icon name="security-check" size="sm" className="shrink-0 text-success" />
      <span>{consentWords(access)}</span>
      <span aria-hidden="true">·</span>
      <span>Staff only</span>
      <span aria-hidden="true">·</span>
      <span>App events are kept {access.retentionMonths} months</span>
      <span aria-hidden="true">·</span>
      <span>Customer since {dateText(access.memberSince, access.window.tz)}</span>
    </p>
  );
}
